import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { Constants } from './_services';

@Component({
  templateUrl: 'public.component.html',
})
export class PublicComponent implements OnInit {
  data: any;
  englishLanguageLabel: string = '';
  frenchLanguageLabel: string = '';

  constructor(private route: ActivatedRoute, private titleService: Title) {
  }

  ngOnInit(): void {
    this.data = this.route.snapshot.data;
    this.titleService.setTitle(this.data.content.windowTitle);

    for (const languageLabel of this.data.content.languageLabel) {
      if (this.englishLanguageLabel && this.frenchLanguageLabel) { break; }

      if (languageLabel.key === Constants.LanguageCodeEnglish) {
        this.englishLanguageLabel = languageLabel.value;
      } else if (languageLabel.key === Constants.LanguageCodeFrench) {
        this.frenchLanguageLabel = languageLabel.value;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/public.component.ts